// Capture before React/auth/lazy routes mount. The browser event is single-use.
interface InstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}
let deferredPrompt: InstallPromptEvent | null = null;
export function hasInstallPrompt(): boolean { return deferredPrompt !== null; }
export function takeInstallPrompt(): InstallPromptEvent | null {
  const prompt = deferredPrompt;
  deferredPrompt = null;
  return prompt;
}
export function isStandalone(): boolean {
  return (navigator as Navigator & { standalone?: boolean }).standalone === true ||
    ["standalone", "fullscreen", "minimal-ui"].some(mode =>
      window.matchMedia(`(display-mode: ${mode})`).matches);
}
export function isIOSDevice(): boolean {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (/macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
}
window.addEventListener("beforeinstallprompt", event => {
  event.preventDefault();
  deferredPrompt = event as InstallPromptEvent;
  window.dispatchEvent(new Event("pwa:install-available"));
});
window.addEventListener("appinstalled", () => { deferredPrompt = null; });
